import { formatDateStringRangeWithLocalTimeZone } from "@/lib/dates/formatters";
import { Space } from "@stenajs-webui/core";
import {
  Card,
  CardBody,
  CardHeader,
  stenaBusinessAgreement,
} from "@stenajs-webui/elements";
import * as React from "react";
import { HeadAgreementStatusCodeChip } from "@/components/chips/HeadAgreementStatusCodeChip";
import { InfoBoxItem } from "../InfoBoxItem";
import { RouteAgreementBox } from "../types";
import { RouteAgreementInfoPairPopover } from "./RouteAgreementInfoPairPopover";

interface Props {
  routeAgreement: RouteAgreementBox;
}

export const RouteAgreementInfoPairBox: React.FC<Props> = ({
  routeAgreement,
}) => {
  return (
    <Card>
      <CardHeader
        variant={"compact"}
        text={"Route agreement"}
        leftIcon={stenaBusinessAgreement}
        contentRight={
          <RouteAgreementInfoPairPopover routeAgreement={routeAgreement} />
        }
      />
      <CardBody flexDirection={"row"} flexWrap={"wrap"} variant={"compact"}>
        <HeadAgreementStatusCodeChip
          statusCode={routeAgreement.statusCode}
          size={"small"}
          key={"head-agreement-infobox-key-0"}
        />
        <Space num={1} />
        <InfoBoxItem
          leftContent={"Validity"}
          rightContent={formatDateStringRangeWithLocalTimeZone({
            dateStringFrom: routeAgreement.valid.start?.isoString,
            dateStringTo: routeAgreement.valid.end?.isoString,
          })}
        />
        <InfoBoxItem
          leftContent={"Type"}
          rightContent={routeAgreement.sailingTypeCodes.join(", ")}
        />
        <InfoBoxItem
          leftContent={"Route"}
          rightContent={
            routeAgreement.agreementNumber && routeAgreement.routeDescription
          }
        />
      </CardBody>
    </Card>
  );
};
